import React, { Component, Fragment } from "react";
import { I18n } from "react-redux-i18n";
import styled from "styled-components";
import Icon from "@alboompro/boom-components/general/icon";
import EditorLabel from "editor/components/EditorLabel";
import { PropListItem, PropLabel } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  position: relative;
  width: 100%;
  height: 130px;
  padding: 0;
  border: none;
  flex-direction: column;
`;

const CustomPropLabel = styled(PropLabel)`
  align-items: flex-start;
  width: 100%;
  margin-bottom: 5px;
`;

const ActionButtons = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  bottom: 10px;
  left: 0;
`;

const ImageManager = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border: 1px solid #dddfe2;
  background-color: #e6f4fe;
  background-image: url(${(props) => props.urlImage && props.urlImage});
  ${(props) =>
    props.urlImage &&
    `
    background-size: contain;
    background-color: #e2e2e2;
    background-repeat: no-repeat;
    background-position: center;
  `}

  :after {
    content: "";
    display: ${(props) => (props.urlImage ? "none" : "block")};
    position: absolute;
    width: 50px;
    height: 50px;
    left: calc(50% - 25px);
    top: 20%;
    background-image: url(https://icons.alboompro.com/v1/bold/files-folders/common-files/BDBDBD/common-file-horizontal-image.svg);
  }
`;

const Button = styled.span`
  display: flex;
  align-items: center;
  height: 25px;
  padding: 1px 7px 2px;
  background-color: #50aff4;
  border-radius: 20px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;

  :focus {
    outline: none;
  }

  :not(:last-child) {
    margin-right: 10px;
  }
`;

const ChangeButton = styled(Button)`
  img {
    margin-right: 5px;
  }
`;

const DeleteButton = styled(Button)`
  background-color: #ff5252;
`;

class ImagePicker extends Component {
  getImgUrl = () => {
    const { currentValue } = this.props;

    if (!currentValue || typeof currentValue === "string") {
      return currentValue;
    }

    const thumb = currentValue.versions.find(
      (img) => img.alias === "thumb" || img.alias === "original_size"
    );
    return thumb.url;
  };

  changeHandler = () => {
    window.alb(
      "cloud",
      "open",
      { multipleSelect: false },
      {
        onFinish: (filesList) => {
          this.handleUpdate(filesList[0]);
        },
      }
    );
  };

  handleUpdate = (imgObj) => {
    const { updaterFn, name } = this.props;
    updaterFn({ prop: name, value: imgObj });
  };

  render() {
    const { label, locale, tooltip } = this.props;
    const imgUrl = this.getImgUrl();
    const tooltipText = (tooltip && tooltip[locale]) || null;
    return (
      <Fragment>
        <CustomPropListItem>
          {label && (
            <CustomPropLabel>
              <EditorLabel tooltip={tooltipText}>{label[locale]}</EditorLabel>
            </CustomPropLabel>
          )}
          <ImageManager urlImage={imgUrl}>
            <ActionButtons>
              <ChangeButton onClick={this.changeHandler}>
                <Icon
                  kind="regular"
                  group="interface-essential"
                  category="multimedia-controls"
                  file="button-refresh-arrows.svg"
                  size="12"
                  color="#fff"
                />
                {I18n.t(
                  `editPanel.imagePicker.${imgUrl ? "changeImage" : "addImage"}`
                )}
              </ChangeButton>
              {imgUrl && (
                <DeleteButton onClick={() => this.handleUpdate(null)}>
                  <Icon
                    kind="bold"
                    group="interface-essential"
                    category="delete"
                    file="bin-1.svg"
                    size="12"
                    color="#fff"
                  />
                </DeleteButton>
              )}
            </ActionButtons>
          </ImageManager>
        </CustomPropListItem>
      </Fragment>
    );
  }
}

export default ImagePicker;
